import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { navLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-fire-line" />
              </span>
              <span className="font-heading text-xl font-extrabold tracking-wide text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteInfo.description}
            </p>
            <p className="mt-4 text-xs text-background-400">
              自 {siteInfo.since} 年起持续整理热门吃瓜时间线
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-background-50">
              站内导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 transition-colors duration-200 hover:text-background-50 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-background-300 transition-colors duration-200 hover:text-background-50 cursor-pointer"
                >
                  投稿与联系
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-background-50">
              主题分类
            </h3>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/events?cat=${cat.slug}`}
                    className="text-sm text-background-300 transition-colors duration-200 hover:text-background-50 cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-widest text-background-50">
              联系我们
            </h3>
            <ul className="mt-4 space-y-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0 text-background-400">
                  <i className="ri-mail-line" />
                </span>
                <span className="break-all">{siteInfo.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-4 h-4 mt-0.5 flex items-center justify-center shrink-0 text-background-400">
                  <i className="ri-lightbulb-line" />
                </span>
                <span className="break-all">投稿爆料：{siteInfo.submitEmail}</span>
              </li>
            </ul>
            <Link
              to="/about#contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-400 cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-edit-2-line" />
              </span>
              投稿纠错
            </Link>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} {siteInfo.name} · 内容仅供信息参考，不构成任何事实认定
          </p>
          <p className="text-xs text-background-400">
            站内时间线均基于公开信息整理 · 涉个人传闻以「待求证」标注
          </p>
        </div>
      </div>
    </footer>
  );
}